<form class="flex-grow-1 flex flex-col p-8 w-full" (submit)="onSubmit()">
    <div class="flex flex-col lg:border-b lg:mb-3">
        <p class="text-2xl">Account information</p>
        <div class="flex flex-col lg:gap-3 lg:flex-row">
            <mat-form-field class="w-full">
                <mat-label>First name</mat-label>
                <input matInput type="text" [formControl]="_form.controls.user.controls.firstName">
                <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.user.controls.firstName)">
                    {{ValidationHelperService.getErrorMessage(_form.controls.user.controls.firstName)}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Last name</mat-label>
                <input matInput type="text" [formControl]="_form.controls.user.controls.lastName">
                <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.user.controls.lastName)">
                    {{ValidationHelperService.getErrorMessage(_form.controls.user.controls.lastName)}}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col lg:gap-3 lg:flex-row">
            <mat-form-field class="w-full">
                <mat-label>Phone number</mat-label>
                <input matInput type="text" [formControl]="_form.controls.user.controls.phoneNumber">
                <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.user.controls.phoneNumber)">
                    {{ValidationHelperService.getErrorMessage(_form.controls.user.controls.phoneNumber)}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Email</mat-label>
                <input matInput type="text" [formControl]="_form.controls.user.controls.email">
                <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.user.controls.email)">
                    {{ValidationHelperService.getErrorMessage(_form.controls.user.controls.email)}}
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="flex flex-col lg:border-b lg:mb-3">
        <p class="text-2xl">Organization information</p>
        <mat-form-field class="w-full">
            <mat-label>Organization name</mat-label>
            <input matInput type="text" [formControl]="_form.controls.organization.controls.organizationName">
            <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.organization.controls.organizationName)">
                {{ValidationHelperService.getErrorMessage(_form.controls.organization.controls.organizationName)}}
            </mat-error>
        </mat-form-field>
        <app-address-form [_form]="_form.controls.organization.controls?.organizationAddress" [prefillInformation]="prefillInformation.organizationAddress"></app-address-form>
        <div class="flex flex-col lg:flex-row">
            <div class="flex flex-col w-full lg:w-1/2 lg:border-r lg:pr-3">
                <p class="text-2xl mb-4">Shipping information</p>
                <app-address-form [_form]="_form.controls.organization.controls?.shippingAddress" [prefillInformation]="prefillInformation.shippingAddress"></app-address-form>
            </div>
            <div class="flex flex-col w-full lg:w-1/2 lg:pl-3">
                <div class="flex flex-row w-full justify-between mb-2">
                    <p class="text-2xl">Billing information</p>
                    <button type="button" mat-flat-button class="text-[var(--color-primary)] text-sm hover:underline" (click)="copyShipping()">Copy shipping</button>
                </div>
                <app-address-form [_form]="_form.controls.organization.controls?.billingAddress" [$triggerCopyShipping]="$triggerCopyShipping" [prefillInformation]="prefillInformation.billingAddress"></app-address-form>
            </div>
        </div>
    </div>
    <div class="flex justify-end gap-3 items-center">
        <button type="button" mat-flat-button color="warn" (click)="_cancel.emit()">Cancel</button>
        <button mat-flat-button color="primary">Submit</button>`
    </div>
</form>
